import styled from "@emotion/styled";

export const MainContent = styled.div`
  min-height: 100vh;
  margin-left: 178px;
  padding-top: 102px;
  background-color: rgb(245, 245, 245);
`;